import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ElementRef,
  Renderer2,
  ApplicationRef ,
  NgZone 
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';


import * as Survey from 'survey-angular';
import { SurveyTriggerCopyValue } from 'survey-core';
import { SurveyService } from '../../service/Survey/survey.service';
import * as SurveyJSON from './surveyJson.json';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';


@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit, OnDestroy {
  @Output() errorMsg = new EventEmitter<string>();

  
  // moved survey JSON to separate file
  surveyObj: Survey.Survey = new Survey.Model(SurveyJSON);
  requestID: any;

  submitAvailable = true;
  surveyCompleted = false;
  questionIndex = 0;
  surveyProgress = false;
  cancelAvailable = true;

  // flag to determine if this is begin viewed from employee mobile app
  isMobileApp: boolean = false;



  private ngDestroy$ = new Subject();

  constructor(
    private surveyService: SurveyService,
    private router: Router,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    private el: ElementRef,
    private renderer: Renderer2,
    private appRef: ApplicationRef,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    let that = this;

    this.route.params.pipe(takeUntil(this.ngDestroy$)).subscribe((params) => {
      //http://localhost:4200/home;mobile=true
      this.isMobileApp = params['mobile'] === 'true' ? true : false;
    });
    
    // set defaults
    this.surveyObj.showNavigationButtons = false;
    this.surveyObj.goNextPageAutomatic = true;
    this.surveyObj.focusFirstQuestionAutomatic = false;

    this.surveyObj.showProgressBar = 'none';
    this.surveyObj.title = '';
    this.surveyObj.description = '';
    this.cancelAvailable = true;
    this.surveyObj.render('surveyElement');
    this.submitAvailable = true;

    this.surveyProgress = !this.surveyObj.isLastPage;
    this.surveyObj.completeText = "Submit"
    const centralTime = moment.tz("America/Chicago").format('MM/DD/YYYY'); // Convert to Central Time and format as ISO 8601
    this.surveyObj.getQuestionByName('careGiverSignDate').value = centralTime.toString();
    this.surveyObj.getQuestionByName('adultSignDate').value = centralTime.toString();
    this.surveyObj.getQuestionByName('minorSignDate').value = centralTime.toString();

    // hide submit button on the last page and enable goNextPageAutomatic
    this.surveyObj.onAfterRenderPage.add((sender) =>
      this.onAfterRenderPage(sender)
    );

    //KHANH
   // this.surveyObj
   //   .onValueChanged
    //  .add(() =>
    //    this.onValueChange()
   //   );
    // Automatically navigate to the next page


    //KHANH
   // Add icon and tooltip on after render
   this.surveyObj.onAfterRenderQuestion.add((sender, options) => {
          // Ensure options and options.question are defined
          if (options && options.question && options.question.name === 'careGiverMRN') {
            const questionElement = options.htmlElement;
            const titleElement = questionElement.querySelector('.sv_q_title');
            // Target the specific question by name
            if (titleElement) {
              // Create a tooltip icon
              const tooltipIcon = this.renderer.createElement('span');
              this.renderer.addClass(tooltipIcon, 'tooltip-icon');
              tooltipIcon.innerHTML = "&#x2139;&#xFE0F;"; // Info icon
            
              // Set the tooltip message
              this.renderer.setAttribute(
                tooltipIcon,
                'aria-label',
                'Note: Patient MRN must be provided on every form to link the form to an actual patient. The Adult Caregiver form includes the MRN field so that we can link that individual to an actual patient.'
              );
            
              // Add a custom tooltip for accessibility and consistency
              this.renderer.setStyle(tooltipIcon, 'position', 'relative');
              const tooltipText = this.renderer.createElement('span');
              tooltipText.innerText = 'Note: Patient MRN must be provided on every form to link the form to an actual patient. The Adult Caregiver form includes the MRN field so that we can link that individual to an actual patient.';
              this.renderer.addClass(tooltipText, 'custom-tooltip');
              this.renderer.appendChild(tooltipIcon, tooltipText);
            
              // Append the tooltip icon to the question title
              this.renderer.appendChild(titleElement, tooltipIcon);
            
              // Adjust question element sizing (if needed)
              this.renderer.setStyle(questionElement, 'height', '120px'); // Adjust as needed
            }
          } else {
            console.log("options or options.question is undefined", options);
          }
  });

    // Add onComplete event listener
    this.surveyObj.onComplete.add((sender: Survey.SurveyModel) => {
      // This is triggered when the survey is completed
      const surveyData = sender.data; // Get the responses from the survey


      
      let model = this.surveyResponseModel;
      // You can send this data to a backend server or handle it however you need
      this.surveyService.submitSurvey(model).subscribe((response: any) => {
        //if (response?.data?.response === 'success') {
         // this.router.navigateByUrl('/confirmation');
       // }
       this.router.navigate(['/confirmation']).then(() => {
        this.ngZone.run(() => {
          this.router.navigate(['/confirmation']);
        });
        
      });
      });
      

    });
  
  }
 
  onValueChange() {
    setTimeout(() => {
     //KHANH this.onNextClick();
      this.cd.detectChanges();
    }, 20);

  }
 // Reset Survey Method
 resetSurvey() {
  this.surveyObj.clear(); // Clear all answers
  this.surveyObj.currentPageNo = 0; // Navigate back to the first page
// Remove the "Start Over" button container
const postSurveyElement = document.getElementById('postSurvey');
if (postSurveyElement) {
  postSurveyElement.innerHTML = ''; // Clear the content inside postSurvey
}
}
  onAfterRenderPage(sender: Survey.SurveyModel) {

    console.log('onAfterRenderPage', {
      isLastPage: this.surveyObj.isLastPage,
      currentPageNo: this.surveyObj.currentPageNo,
    });

    if (this.surveyObj.isLastPage) {
     // this.submitAvailable = true; //KHANH
   

      console.log('Last page')
      console.log(sender.currentPage.name)

      if (sender && this.surveyObj.currentPage && this.surveyObj.currentPage.name === 'otherNotLegal') {
        console.log('Inside Last page')
      const container = document.createElement('div');
      container.style.marginTop = '20px'; // Add spacing from the survey
      container.style.textAlign = 'center'; // Optional: Center align the button

      const startOverButton = document.createElement('button');
      startOverButton.innerText = 'Done';
      startOverButton.className = 'btn btn-primary mt-3';
      startOverButton.onclick = () => this.resetSurvey();

      container.appendChild(startOverButton);
      document.getElementById('postSurvey')?.appendChild(container);
      }
    }
    setTimeout(() => window.dispatchEvent(new Event('resize')),0)
  }

  /**
   * Handle Next button survey click event
   */
  onNextClick() {
    // submit and show completed verbiage
    if (
      !this.surveyObj.isCurrentPageHasErrors &&
      this.surveyObj.currentPageNo == 9
    ) {
      console.log('onNextClick doComplete');
      this.surveyCompleted = true;
      this.submitAvailable = false;
      this.surveyProgress = false;
      this.cancelAvailable = false;
      let model = this.surveyResponseModel;

      this.surveyService.submitSurvey(model).subscribe((response: any) => {
        if (response?.data?.response === 'success') {
          if (!this.requestID) {
            this.requestID = response.data.requestID;
          }
        }
      });
      return this.surveyObj.doComplete();
    } else {

      console.log('onNextClick');
      let model = this.surveyResponseModel;

      this.surveyService
        .submitQuestionResponse(model)
        .pipe(catchError(this.handleError<Object>('Error saving.')))
        .subscribe((response: any) => {
          if (response?.data?.response === 'success') {
            if (!this.requestID) {
              this.requestID = response.data.requestID;
            }
          }
        });

      return this.surveyObj.nextPage();
    }
  }

  /**
   * Handle Cancel button click event
   */
  onCancelClick() {
    console.log('onCancelClick');
    let model = this.surveyResponseModel;
    console.log(this.requestID);
    if (this.requestID && !this.surveyCompleted) {
      this.surveyService
        .cancelSurvey(model)
        .pipe(catchError(this.handleError<Object>('Error saving.')))
        .subscribe((response: any) => {
          this.surveyObj.clear();
          this.surveyObj.start();
          this.surveyCompleted = false;
          this.submitAvailable = true;
          this.requestID = null;
        });
    } else {
      this.surveyObj.clear();
      this.surveyObj.start();
      this.surveyCompleted = false;
      this.submitAvailable = true;
    }
  }

  /**
   * Handle survey navigation component click event
   */
  onPageChanged(pageNo: number) {

    console.log('onPageChanged', pageNo);
    let model = this.surveyResponseModel;

    this.surveyService
      .submitSurvey(model)
      .pipe(catchError(this.handleError<Object>('Error saving.')))
      .subscribe((response: any) => {
        if (response?.data?.response === 'success') {
          if (!this.requestID) {
            this.requestID = response.data.requestID;
          }
          // change the current page using visible page zero-based index
          this.surveyObj.currentPage = Math.max(pageNo - 1, 0);
        }
      });
  }


  /**
   * Handle End Survey button survey click event
   */
  onEndClick() {
    console.log('onEndClick');
    this.surveyCompleted = true;
    this.submitAvailable = false;
    this.surveyProgress = false;
    this.cancelAvailable = false;
    let model = this.surveyResponseModel;

    this.surveyService.submitSurvey(model).subscribe((response: any) => {
      if (response?.data?.response === 'success') {
        if (!this.requestID) {
          this.requestID = response.data.requestID;
        }
      }
    });

    this.surveyObj.doComplete();
  }

  private get surveyResponseModel() {
    let model = {
      ...this.surveyObj.data,
      requestID: this.requestID,
      surveyPostId: this.surveyObj.surveyPostId,
      isCancelled: '',
      cancelPageNumber: this.surveyObj.currentPageNo + 1,
      isEnded: this.surveyCompleted ? 'Yes' : 'No',
      isMobile: this.isMobileApp,
      endPageNumber: this.surveyCompleted
        ? this.surveyObj.currentPageNo + 1
        : 0, //zero-basssed page #
      questionResponse: JSON.stringify(this.surveyObj.data),
    };
    return model;
  }

  private handleError<T>(
    operation = 'operation',
    result?: T
  ): (error: any) => Observable<T> {
    return (error: any): Observable<T> => {
      // console.log({error, operation});
      // this.errorMsg.emit(`${operation} ${error.statusText}.`);
      
      return of(result as T);
    };
  }

  ngOnDestroy() {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }
}
